<template>
  <div style="width: 100%">

    <div class="pa-4">
      <div class="d-flex align-center">
        <router-link to="/app/management/profiles" class="text-decoration-none">
          <h2 class="mb-2 mr-4 breadcrumb-link"
            style="font-weight: 400; color: #203a75; font-size: 1.5rem; background-color: #f5f5f5; padding: 8px 20px; border-radius: 6px; cursor: pointer;">
            Unidades de Negócio
          </h2>
        </router-link>
        <v-icon class="mx-2" color="grey">mdi-chevron-right</v-icon>
        <h2 class="mb-2 text--secondary" style="font-weight: 400; font-size: 1.5rem;">
          {{ this.form.name }}
        </h2>
      </div>
    </div>

    <div class="mx-4">
      <div style="display: flex; gap: 16px;">
        <div style="width: 20%;">
          <v-card outlined class="mt-2">
            <div class="pa-4 pb-3">
              <p class="text-h6">Perfil de Veículo</p>

              <p class="font-weight-medium">{{ this.form.displayName }}</p>

              <p class="font-weight-medium mt-4">Cadastrado em {{ formatDate(this.form.createdOn) }}</p>

              <div class="d-flex align-center">
                <p class="ma-0 pa-0 font-weight-medium">Situação RFB:</p>
                <v-chip class="white--text ml-1" small :color="loadingStatusCNPJ()">
                  {{ statusCNPJ }}

                  <v-progress-circular v-if="statusCNPJ === null" color="white" size="20" height="7"
                    indeterminate></v-progress-circular>
                </v-chip>
              </div>
            </div>

            <v-tabs v-model="tab" vertical left>
              <v-tab :class="['menu-vertical', 'd-flex', 'justify-start']"><v-icon small class="mr-1">
                  mdi-pencil-outline </v-icon>Dados
                Cadastrais
              </v-tab>

              <v-tab :class="['menu-vertical', 'd-flex', 'justify-start']"><v-icon small class="mr-1">
                  mdi-map-marker-outline </v-icon>Endereços
              </v-tab>

              <v-tab :class="['menu-vertical', 'd-flex', 'justify-start']"><v-icon small class="mr-1">
                  mdi-view-dashboard-outline </v-icon>Inventário
              </v-tab>

              <v-tab :class="['menu-vertical', 'd-flex', 'justify-start']"><v-icon small class="mr-1">
                  mdi-bank </v-icon>Dados bancários
              </v-tab>

              <!-- <v-tab :class="['menu-vertical', 'd-flex', 'justify-start']"><v-icon small class="mr-1">
                  mdi-history </v-icon>Histórico
              </v-tab> -->
            </v-tabs>
          </v-card>
        </div>
        <div style="flex: 1;">
          <v-card outlined class="mt-2">
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <ProfileDataForm :profileData="form" :profileId="profileId" :isCnpjInactive="isCnpjInactive" />
              </v-tab-item>

              <v-tab-item>
                <AddressProfile :profileId="profileId" :isCnpjInactive="isCnpjInactive" />
              </v-tab-item>

              <v-tab-item>
                <InventoryProfile :profileId="profileId" :isCnpjInactive="isCnpjInactive" />
              </v-tab-item>

              <v-tab-item>
                <BankDataProfile :profileId="profileId" :profile="form" :isCnpjInactive="isCnpjInactive" />
              </v-tab-item>

              <!-- <v-tab-item>
                <HistoryProfile :profileId="profileId" :isCnpjInactive="isCnpjInactive" />
              </v-tab-item> -->
            </v-tabs-items>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { getAuth } from '@/services/authService'
import ProfileDataForm from './ProfileDataForm.vue';
import AddressProfile from './AddressProfile.vue';
import InventoryProfile from './InventoryProfile.vue';
import BankDataProfile from './BankDataProfile.vue';
// import HistoryProfile from './HistoryProfile.vue';

export default {
  name: "ProfileDetails",
  components: {
    ProfileDataForm,
    AddressProfile,
    InventoryProfile,
    BankDataProfile
  },
  props: {
    profileId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
      statusCNPJ: null,
      testInactiveCnpj: false, 
      form: {
        name: "",
        displayName: "",
        id: "",
        document: "",
      },
    };
  },

  computed: {
    auth() {
      return getAuth()
    },
    isCnpjInactive() {
      
      if (this.testInactiveCnpj) return true;
      return this.statusCNPJ === "BAIXADA" || this.statusCNPJ === "INAPTA";
    }
  },

  watch: {
    tab(val) {
      let tabName = ''

      switch (val) {
        case 0: tabName = 'cadastral'; break;
        case 1: tabName = 'address'; break;
        case 2: tabName = 'inventories'; break;
        case 3: tabName = 'bank-data'; break;
        case 4: tabName = 'history'; break;
      }

      if (this.$route.query.tab != tabName) {
        this.$router.replace(`/app/management/profiles/${this.profileId}?tab=${tabName}`)
      }
    },
  },

  async mounted() {

    if (this.$route.query) {
      const searchObject = { ...this.$route.query }

      switch (searchObject.tab) {
        case 'cadastral':
          this.changeTab(0)
          break;
        case 'address':
          this.changeTab(1)
          break;
        case 'inventories':
          this.changeTab(2)
          break;
        case 'bank-data':
          this.changeTab(3)
          break;
        case 'history':
          this.changeTab(4)
          break;
        default:
          break;
      }
    }


    if (this.profileId) {
      this.loadProfileData();
    }
  },

  methods: {
    changeTab(item) {
      this.tab = item;
    },

    async loadProfileData() {
      try {
        const response = await this.$axios.get(`profiles/admin/all?type=2&q=${this.profileId}`);

        if (response.data.data.data && response.data.data.data.length > 0) {
          this.form = response.data.data.data[0];
          this.checkDocument();
        }
      } catch (error) {
        console.error('Erro ao carregar dados do perfil:', error);
      }
    },

    async checkDocument() {
      try {
        if (!this.form.document) return;

        const cnpjFormatted = this.form.document.replace(/[^\d]/g, "");
        const response = await this.$axios.post(`assets/checker/documentId`, {
          input: "documentId",
          value: cnpjFormatted,
        });

        if (response.data && response.data.data && response.data.data.companyData) {
          this.statusCNPJ = response.data.data.companyData.situacao;
        }
      } catch (error) {
        console.error('Erro ao verificar documento:', error);
        this.statusCNPJ = 'Erro';
      }
    },

    loadingStatusCNPJ() {
      if (this.statusCNPJ === "ATIVA") {
        return "green";
      } else if (this.statusCNPJ === "BAIXADA") {
        return "red";
      } else if (this.statusCNPJ === "INAPTA") {
        return "red";
      } else {
        return "grey";
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      if (dateString.includes(' ')) {
        const [datePart] = dateString.split(' ');
        const [year, month, day] = datePart.split('-');
        return `${day}/${month}/${year}`;
      }
      if (dateString.includes('-')) {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
      }

      return dateString;
    },


  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}

.menu-vertical {
  text-align: left !important;
  font-size: 14px;
  height: 40px !important;
  color: #0e1439 !important;
}

.v-tab {
  color: #0e1439 !important;
  font-weight: 300 !important;
}

.v-tab .v-icon {
  color: #0e1439 !important;
}

.v-tab--active {
  font-weight: bold !important;
  background-color: rgba(14, 20, 57, 0.08) !important;
}

.theme--light.v-sheet {
  border-color: rgb(168, 168, 168) !important;
}
</style>